import styled from "styled-components";

import { windowWidth } from "@styles/global";

// Telluria
import { Button } from "@npm-telluria-tecnologia/telluria-ui";

const Container = styled.div`
  padding: 0 30px 100px 30px;

  > :not(:last-child) {
    margin-bottom: 15px;
  }
`;

const LinkContractButtonContent = styled.div`
  width: calc(100% - 60px);
  display: flex;
  justify-content: center;
  bottom: 15px;
  position: absolute;

  @media (max-width: ${windowWidth.tablet}) {
    width: 100%;
  }
`;

const LinkContractButton = styled(Button)`
  margin-top: 20px !important;
  background-color: ${(props) => props.theme.colors.primary} !important;
  font-size: 12px !important;
  padding: 15px 25px !important;
  border-radius: 50px !important;

  :hover {
    background-color: ${(props) => props.theme.colors.secondary} !important;
  }
`;

export { Container, LinkContractButton, LinkContractButtonContent };
